// Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved

import { css } from 'emotion';
import React, { useState, useEffect ,} from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { loadRoutes, setCount } from '../actions';
import ParcelItem from './ParcelItem';
import { COLOR } from '../const'
// import axios from 'axios';
import { getParcel } from '../api/githubAPI';
import Modal from './Modal';
import ParcelDetail from './ParcelDetail';

const RouteList = () => {
  
  const routesCount: any = useSelector((state: any) => state.Route.routes.length)
  const { keyword, date, sort, skip } = useSelector((state: any) => state.Search)
  const { sender, status, service } = useSelector((state: any) => state.Filter)
  const dispatch = useDispatch();
  
  
  const [isLoading, setIsLoading] = useState<boolean>(false)
  
  const [reload, setReload] = useState<number>(0)
  const [issuesError, setIssuesError] = useState<Error | null>(null)

  async function fetchEverything() {
    async function fetchRoutes() {
      const RoutesResult:any = await getParcel(keyword, date, sort, skip, sender, status, service)
      dispatch(loadRoutes(RoutesResult.routes))
      if(RoutesResult.count!==routesCount){
        dispatch(setCount(RoutesResult.count))
      }
      
    }

    try {
      await Promise.all([fetchRoutes()])
      setIssuesError(null)
    } catch (err) {
      console.error(err)
      setIssuesError(err)
    } finally {
      setIsLoading(false)
    }
  }
  
  useEffect(() => {
    setIsLoading(true)
    if(isLoading){
      fetchEverything();
    }
    
    
  }, [ keyword, date, sort, skip]);

  useEffect(() => {
    setReload(reload + 1);
    fetchEverything();
    // console.log('sender',sender, status,   service)
    
  }, [sender, status, service]);
  
  useEffect(() => {
    const interval = setInterval(() => {
      setReload(reload + 1);
    }, 5000);
    // console.log(reload)
    fetchEverything();
    return () => {
      clearInterval(interval);
    };
  }, [reload]);

  if (issuesError) {
    return (
      <div>
        <h1>Something went wrong...</h1>
        <div>{issuesError.toString()}</div>
      </div>
    )
  }

  let renderedList = isLoading ? (
    <h3>Loading...</h3>
  ) : (
    <div key={'1-1'} className={styles.divTableBody}>

    {new Array(routesCount).fill(null).map((_, index:number) => (
      <ParcelItem index={index}  key={`ri-${index}`}></ParcelItem>
    ))}


  </div>
  )

  return (
    <div key={'1-2'} className={styles.divTable}>
      <div className={styles.divTableHeading} >
        <div className={styles.divTableRow}>
        <div className={styles.divTableCell}>NO.</div>
          <div className={styles.divTableCell}>STATUS</div>
          <div className={styles.divTableCell}>SENDER</div>
          <div className={styles.divTableCellMaxWidth}>CREATE DELIVERY</div>
          <div className={styles.divTableCell}>PROGRESS</div>
          <div className={styles. divTableCellMaxWidth}>SERVICE</div>
          <div className={styles.divTableCell}>SHIPPING NO.</div>
          <div className={styles.divTableCell}>PRICE</div>
        </div>
      </div>
     {renderedList}
     {<Modal>
        <ParcelDetail/>
      </Modal>}
    </div>
  )
}


const styles = {
  count: css`
    font-size: 12px;
  `,
  lastUpdated: css`
    color: #666;
    font-size: 10px;
  `,
  todos: css`
    padding-left: 0;
  `,
  divTable: css`
    display: table;
    width: 100%;
    `,
  divTableRow: css`
    display: table-row;
    background-color: #ffffff;
    box-shadow: 0px -1px 3px rgba(0,0,0,0.13);
    border-radius: 23px 0px 0px 0px;
    `,
  divTableHeading: css`
    background-color: #EEE;
    display: table-header-group;
    `,
  divTableCell: css`
    // broute: 1px solid #999999;
    display: table-cell;
    padding: 3px 10px;
    text-align: center;
    padding: 10px;
    text-align: center;
    font-weight: bold;
    font-size: 18px;
    color: ${COLOR['BLUE_DARK']};
    &:nth-child(1){
      border-radius: 23px 0px 0px 0px;
    }
    `,
    divTableCellMaxWidth: css`
    // broute: 1px solid #999999;
    display: table-cell;
    padding: 3px 10px;
    text-align: center;
    padding: 10px;
    text-align: center;
    font-weight: bold;
    font-size: 18px;
    color: ${COLOR['BLUE_DARK']};
    min-width: 152px;
    &:nth-child(1){
      border-radius: 23px 0px 0px 0px;
    }
    `,
  divTableHead: css`
    // broute: 1px solid #999999;
    display: table-cell;
    padding: 3px 10px;
    `,
  divTableBody: css`
      display: table-row-group;
   `,

};
export default RouteList